// LICENSE_CODE ZON
'use strict'; /*jslint ts:true, react:true*/
import React, {useState, useEffect, useContext} from 'react';
import {Settings_context} from '../settings_ctx';
import {use_download} from '../shared/use_download';
import {use_screen} from '../lib/screen_util';
import {Button} from '../../../shared/button';
import {Editor} from '../../../shared/editor/editor';
import cn from 'classnames';
import styles from './no_image_download_banner.module.less';

export const No_image_download_banner = ()=>{
    const {theme} = useContext(Settings_context);
    const [bottom_text, set_bottom_text] = useState('Sit back, relax and enjoy'
        + ' global games, movies, series and more on your desktop!');
    const {download_br} = use_download();
    const on_download = ()=>{
        download_br({cb: ()=>{
          // waiting for iframe to start actial downloading
          setTimeout(()=>{
              // absolute link for holabrowser.com
              window.location.href =
                  'https://hola.org/after_download?s=install&browser=1';
          }, 1000);
        }});
    };
    const {screen} = use_screen();
    useEffect(()=>{
        if (screen=='lg' || screen=='md')
        {
            set_bottom_text('On the move? Never miss another episode,'
                + ' movie, game or match!');
        }
        if (screen=='xs' || screen=='sm')
        {
            set_bottom_text('Never miss another episode, movie,'
                + ' game or match!');
        }
    }, [screen]);

    return <div className={styles.container}>
      <div className={cn(styles.title_plus_btn, theme.root)}>
        <h3>{bottom_text}</h3>
        <Button on_click={on_download}
          caption="Download Hola Browser"
          color="black2023" size="lg" arrow txt_colored />
      </div>
    </div>;
};

interface i_no_image_download_banner_editor_props {
    value: unknown;
    on_change: (new_val: unknown)=>void;
}

export const No_image_download_banner_editor = (
{value, on_change}: i_no_image_download_banner_editor_props
)=>{
    return <Editor value={value} on_change={on_change} editors={[]}/>;
};
